// Acciones sobre la central 3CX por el Puente XmarteK (D80): llamar, transferir, colgar, pegar datos a la llamada,
// colas, horario, devoluciones automaticas y desvio. El servicio de tiempo real valida permisos y firma la orden.
import { request } from './http';

export type ColaPuente = { extension: string; nombre: string; esperando: number; agentes: { extension: string; nombre: string; conectado: boolean }[] };
export type Devolucion = { id: string; estado: string; numero: string; destino: string; motivo: string; en: string };
export type ConfigDevoluciones = {
  activo: boolean;
  extensionDevoluciones: string;
  desdeColas: boolean;
  desdeExtensiones: boolean;
  esperarMin: number;
  intentos: number;
  entreIntentosMin: number;
  timbrarSeg: number;
};
export type EstadoPuente = {
  registrado: boolean;
  extension: string | null;
  admin: boolean;
  // Roles y permisos (D99): «Supervisar llamadas» y «Colas de otros». Un servicio viejo no los manda: cuenta admin.
  supervisa?: boolean;
  colas?: boolean;
  desvio: string | null;
  config: ConfigDevoluciones;
  devoluciones: Devolucion[];
};

export const estadoPuente = () => request<EstadoPuente>('/rt/api/puente/estado');
export const accionPuente = <T = { ok: boolean }>(accion: string, datos: Record<string, unknown> = {}) =>
  request<T>('/rt/api/puente/accion', { method: 'POST', body: { accion, ...datos } });
export const colasPuente = () => accionPuente<{ ok: boolean; colas: ColaPuente[] }>('colas').then((r) => r.colas ?? []);
export const horarioPuente = () =>
  accionPuente<{ ok: boolean; departamentos: { nombre: string; modo: string; hasta: string }[] }>('horario-estado').then((r) => r.departamentos ?? []);

export const ESTADO_DEVOLUCION: Record<string, string> = {
  programada: 'Programada',
  registered: 'Esperando que el destino esté libre',
  dialing: 'Llamando al cliente',
  answered: 'El cliente contestó',
  transferred: 'Pasada al agente',
  no_answer: 'El cliente no contestó',
  failed: 'Falló',
};
